export function pullAt<T>(arr: T[], indexes: number[]) {
  const sorted = [...indexes].sort((a, b) => b - a); // remove from end
  const removed: T[] = [];

  for (const i of sorted) {
    if (i >= 0 && i < arr.length) {
      removed.unshift(arr.splice(i, 1)[0]);
    }
  }

  return removed;
}

export function compact<T>(value: (T | null | undefined)[]): T[] {
  return value.filter((item): item is T => item !== null && item !== undefined);
}

export function hasItems(value: unknown): value is unknown[] {
  return Array.isArray(value) && compact(value).length > 0;
}

export function hasKeys(value: unknown): value is Record<string, unknown> {
  return Boolean(
    value && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length > 0
  );
}

export function isString(value: unknown): value is string {
  return typeof value === 'string' && value.trim().length > 0;
}

export function distinctStrArr(value: (string | null | undefined)[]) {
  const validItems = value.filter(
    (v): v is string => v !== '' && v !== 'null' && v !== null && v !== undefined
  );
  const uniqueItems = new Set(validItems);
  return Array.from(uniqueItems);
}
